<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mintalMesPrdMonthPlanResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      with-custom-row-actions-first-column
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button
                                            type="gotoChild"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="查看班次计划"
                                            @click="gotoChildPage(customRowScope.row)">
                                        </em-button>
                                        <em-button
                                            type="gotoChild"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="重新计算班次计划产出"
                                            custom-icon="fa fa-repeat"
                                            :busy="calLoading"
                                            @click="calShiftPlanOutput(customRowScope.row)">
                                        </em-button>
                                        <em-button
                                            type="gotoChild"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="重新生成物料需求计划"
                                            custom-icon="fa fa-th-list"
                                            :busy="calLoading"
                                            @click="recreateMaterialRequirePlan(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author liang gang qiang
// Date 2021-10-14 10:06:24

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";

export default {
    name: "mintalMesPrdMonthPlanListView",
    mixins: [emCommonListMixin, emCommonGotoMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    data() {
        return {
            calLoading: false
        }
    },
    methods: {
        gotoChildPage(row) {
            this.$_emGotoMixin_gotoHolderList("mintalMesPrdShiftPlan"
                , {prdMonthIdFilter: row.id}
                , {prdMonthId: row.id}, false, {});
        },
        calShiftPlanOutput(row) {
            this.calLoading = true;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_MINTALMES_PRD_URL + "/mintalMesPrdMonthPlan/calShiftPlanOutput",
                data: {
                    id: row.id
                }
            }).then(() => {
                this.$message.success('操作成功');
            }).finally(() => this.calLoading = false);
        },
        recreateMaterialRequirePlan(row) {
            this.calLoading = true;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_MINTALMES_PRD_URL + "/mintalMesPrdMaterialRequirePlan/createPlan?monthPlanId=" + row.id,
            }).then(() => {
                this.$message.success('操作成功');
            }).finally(() => this.calLoading = false);
        }
    }
};
</script>